import React from 'react';
import block from 'bem-cn';

import SVG from 'components/SVG';

import searchSvg from './img/search.svg';
import crossSVG from './img/cross.svg';

import './InputSearch.scss';

const b = block('input-search-mobile');

const InputSearch = ({ onClick,clearInput, ...restProps }) => {
  return (
    <div className={b()}>
      <div onClick={onClick}>
        <SVG className={b('search-icon')} svgProps={{ svg: searchSvg }} />
      </div>
      <input {...restProps} className={b('input')} type="search" />
      <div className={b('clear-input')} onClick={clearInput}>
        <SVG className={b('cross')} svgProps={{ svg: crossSVG }} style={{ opacity: restProps.value ? 1 : 0 }} />
      </div>
    </div>
  );
};

export default InputSearch;
